import { useEffect, useState, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useCustomNavigate } from 'core/hooks/useCustomNavigate'
import { RouterName, route } from "core/router";
import {
  AiChefTypeEnum,
  IAiImgRequest,
  IAiImgResponse,
} from './../store/types';
import {
  FetchDataRequest,
  setDataAiChef,
  resetAiChef,
  selectIngredients,
  updateRequestType as updateRequestTypeAction,
} from './../store/actions';
import { useRecipe } from "modules/Ingredients/hooks/recipe";
import { useResetRecipe } from "modules/Recipes/hooks/recipe";

export const useResetAiChef = () => {
  const dispatch = useDispatch()
  const onReset = (resetParam: boolean = true) => {
    dispatch(resetAiChef(resetParam))
  }

  return {
    onReset
  }
}

export const useAiChef = (type: AiChefTypeEnum, file?: any) => {
  const { src: url, error } = file || {};
  const navigate = useCustomNavigate()
  const dispatch = useDispatch()
  const loadingAiImg = useSelector((state: any) => state.AiChef.loading);
  const dataAnalytics = useSelector((state: any) => state.AiChef.data);
  const errorAnalytics = useSelector((state: any) => state.AiChef.error);
  const detail = useSelector((state: any) => state.Recipes.detail);
  const params = useSelector((state: any) => state.AiChef.params);
  console.log('params', params);
  
  const [open, setOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [redirectTo, setRedirectTo] = useState<string>('');
  const [retryUpload, setRetryUpload] = useState<boolean>(false);
  const [isBoth, setIsBoth] = useState<boolean>(false);
  const { setIngradients } = useRecipe();
  const onResetRecipe = useResetRecipe();
  const routeHistories = useSelector((state: any) => state.Common.routes);
  const lastPageIndex = routeHistories.findLastIndex((item: any) => !item?.path?.includes('ai-chef'));
  const lastPage = routeHistories[lastPageIndex]?.path;
  const showLoading = useMemo(() => {
    return file?.uploading || loadingAiImg
  }, [file?.uploading, loadingAiImg])

  useEffect(() => {
    console.log('57------dataAnalytics', dataAnalytics);
    
    if (dataAnalytics && dataAnalytics.type) {
      // case both type
      if (
        dataAnalytics.type === AiChefTypeEnum.all 
        // [AiChefTypeEnum.meal, AiChefTypeEnum.ingredient].includes(dataAnalytics.type)
        // && [AiChefTypeEnum.meal, AiChefTypeEnum.ingredient].includes(type)
        && dataAnalytics.data.ingredient?.length
        && dataAnalytics.data.meal?.length
      ) {
        setIsBoth(true)
        return;
      }

      if (dataAnalytics.type === AiChefTypeEnum.unknown) {
        setMessage('unknow')
        return setOpen(true)
      }

      if (dataAnalytics.type === AiChefTypeEnum.ingredient) {
        return navigate(route(RouterName.AI_CHEF_INGREDIENTS))
      }

      if (dataAnalytics.type === AiChefTypeEnum.meal) {
        return navigate(route(RouterName.AI_CHEF_RECIPES))
      }

      // // analyze the data type to redirect to the correct page
      // // analyze success in ai chef page
      // if (
      //   dataAnalytics.type === AiChefTypeEnum.meal
      //   && type === AiChefTypeEnum.meal
      // ) {
      //   return navigate(route(RouterName.AI_CHEF_RECIPES))
      // }
      // // analyze success in ingredient page
      // if (
      //   dataAnalytics.type === AiChefTypeEnum.ingredient
      //   && type === AiChefTypeEnum.ingredient
      // ) {
      //   return navigate(route(RouterName.AI_CHEF_INGREDIENTS))
      // } 
      // // analyze success but not match type
      // if (
      //   dataAnalytics.type !== type
      //   && dataAnalytics.type !== AiChefTypeEnum.unknown
      //   && dataAnalytics.data?.length
      // ) {
      //   if (type === AiChefTypeEnum.meal) {
      //     setMessage('not_recipes')
      //     setRedirectTo(RouterName.AI_CHEF_INGREDIENTS)
      //   } else if (type === AiChefTypeEnum.ingredient) {
      //     setMessage('not_ingredients')
      //     setRedirectTo(RouterName.AI_CHEF_RECIPES)
      //   } else {
      //     setMessage('error')
      //   }
      //   return setOpen(true)
      // }
      // setMessage('unknow')
      // return setOpen(true)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataAnalytics, type])

  const fetchData = useCallback((data: IAiImgRequest) => {
    setRedirectTo('')
    setRetryUpload(false)
    // reset ingredients selected
    setIngradients([])
    onResetRecipe()
    dispatch(FetchDataRequest(data))
    dispatch(selectIngredients([]))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FetchDataRequest])

  useEffect(() => {
    if (url) {
      fetchData({ url });
    }
  }, [url, fetchData])

  useEffect(() => {
    
    if (errorAnalytics) {
      console.log('errorAnalytics', errorAnalytics);
      if (errorAnalytics?.status === 400) {
        setMessage('unknow')
        setOpen(true)
        return;
      }else{
        setMessage('error')
        setOpen(true)
      }
    }
  }, [errorAnalytics])

  useEffect(() => {
    if (error) {
      setMessage('upload_fail')
      setRetryUpload(true)
      setOpen(true)
    }
  }, [error])

  useEffect(() => {
    if (file?.uploading) {
      (window as any).webViewRequestAdmob("FULL_SCREEN")
    }
  }, [file?.uploading])

  useEffect(() => {
    if (!loadingAiImg && !!file) {
      (window as any).webViewRequestCloseAdmob()
    }
  }, [loadingAiImg, !!file])

  const updateRequestType = useCallback((type: AiChefTypeEnum) => {
    dispatch(updateRequestTypeAction({
      id: dataAnalytics?.request_id,
      analyze_type: type.toUpperCase()
    }))
  }, [dispatch, dataAnalytics])

  return {
    params,
    isBoth,
    setIsBoth,
    fetchData,
    loadingAiImg,
    dataAnalytics,
    redirectTo,
    message,
    open,
    setOpen,
    retryUpload,
    detail,
    lastPage,
    showLoading,
    updateRequestType,
  };
}

const mapItemHistoryToAIResponse = (itemHistory: any): IAiImgResponse => {
  return {
    request_id: itemHistory.id,
    title: itemHistory.analyze_title,
    type: itemHistory.analyze_type.toLowerCase(),
    data: {
      ingredient: itemHistory.response_ingredients.map((item: any) => ({
        id: item.pivot.reference_id,
        name: item.translates?.[0]?.name || '',
        responses: [{
          id: item.id,
          pivot: {
            content: item.content,
            recipe_request_id: item.pivot.recipe_request_id,
            reference_id: item.pivot.reference_id,
          }
        }],
      })),
      meal: itemHistory.response_meals.map((item: any) => ({
        id: item.pivot.reference_id,
        lang_id: item.lang_id,
        name: item.name || '',
        thumbnail: '',
        video_id: item.video_id,
        content: '',
        created_at: item.created_at,
        updated_at: item.created_at,
      })),
    }
  }
}

export const useGoToAiChef = () => {
  const navigate = useCustomNavigate()
  const dispatch = useDispatch()
  const { setIngradients } = useRecipe();
  const goToAiChef = (itemHistory: any) => {
    if (!itemHistory) {
      return;
    }
    setIngradients([])
    const { analyze_type } = itemHistory;
    const type = analyze_type.toLowerCase();
    const data = mapItemHistoryToAIResponse(itemHistory);
    dispatch(setDataAiChef({
      data,
      params: {
        url: itemHistory.files?.[0]?.url?.medium || '',
      }
    }))
    if (type === AiChefTypeEnum.meal) {
      navigate(route(RouterName.AI_CHEF_RECIPES))
    }
    if (type === AiChefTypeEnum.ingredient) {
      navigate(route(RouterName.AI_CHEF_INGREDIENTS))
    }
  }

  return {
    goToAiChef
  }
}
